<template>
  <div style="padding: 10px">
    <el-card>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane :key="0" :label="$t('tablePrice.siteDimensionTab')" name="first">
          <siteIndex v-if="isShow" />
        </el-tab-pane>
        <el-tab-pane :key="1" :label="$t('tablePrice.regionDimensionTab')" name="second">
          <regionIndex v-if="isShow1" />
        </el-tab-pane>
        <el-tab-pane :key="2" :label="$t('tablePrice.customerDimensionTab')" name="third">
          <customerIndex v-if="isShow2" />
        </el-tab-pane>
        <el-tab-pane :key="3" :label="$t('tablePrice.riderDimensionTab')" name="fourth">
          <riderIndex v-if="isShow3" />
        </el-tab-pane>
      </el-tabs>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'BagWork',
  components: {
    siteIndex: () => import('./component/siteIndex.vue'),
    regionIndex: () => import('./component/regionIndex.vue'),
    customerIndex: () => import('./component/customerIndex.vue'),
    riderIndex: () => import('./component/riderIndex.vue')
  },
  data() {
    return {
      activeName: 'first',
      isShow: true,
      isShow1: false,
      isShow2: false,
      isShow3: false
    };
  },
  methods: {
    handleClick(tab, event) {
      this.isShow = tab.name === 'first';
      this.isShow1 = tab.name === 'second';
      this.isShow2 = tab.name === 'third';
      this.isShow3 = tab.name === 'fourth';
    }
  }
};
</script>

<style scoped></style>
